import script from "./UiTableMonitoringTd.vue?vue&type=script&setup=true&lang=js"
export * from "./UiTableMonitoringTd.vue?vue&type=script&setup=true&lang=js"

import "./UiTableMonitoringTd.vue?vue&type=style&index=0&id=5f0f1042&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f0f1042"]])

export default __exports__